<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute, onBeforeRouteLeave } from "vue-router";

import { useCurrentMenuStore } from "../../stores/current-menu";

import CategoryModal from "../../components/modals/CategoryModal";

import draggable from "vuedraggable";
import Grid from "../../components/Grid";
import SiteList from "../../components/menus/SiteList";
import MenuCategory from "../../components/menus/MenuCategory";
import { tupleExpression } from "@babel/types";
import { LottieAnimation } from "lottie-web-vue"


const route = useRoute();

const loading = ref(false);

const currentMenuStore = useCurrentMenuStore();

async function init() {
  await currentMenuStore.getCurrentMenu(route.params.menu);

  Object.assign(currentMenuStore.foodTemp, JSON.parse(currentMenuStore.currentMenu.food));
  Object.assign(currentMenuStore.food, JSON.parse(currentMenuStore.currentMenu.food));

  Object.assign(
    currentMenuStore.drinkTemp,
    JSON.parse(currentMenuStore.currentMenu.drink)
  );
  Object.assign(currentMenuStore.drink, JSON.parse(currentMenuStore.currentMenu.drink));
}

function addCategory(menuType, category) {
  if (menuType === "food") {
    currentMenuStore.food.push({
      name: category,
      active: true,
      contents: [],
    });
  } else if (menuType === "drink") {
    currentMenuStore.drink.push({
      name: category,
      active: true,
      contents: [],
    });
  }
}

document.addEventListener('scroll', function (e) {
  // get distance of .menu-view__header from top of window
  const header = document.querySelector(".menu-view__header");
  let distance = header.getBoundingClientRect().top;

  let trigger = getComputedStyle(header).getPropertyValue('--inside-padding-horiz').slice(0, -2);

  if (distance == trigger) {
    document.querySelector(".menu-view__header").classList.add("sticky");
  } else {
    document.querySelector(".menu-view__header").classList.remove("sticky");
  }

});

onMounted(async () => {
  loading.value = true;
  await init();
  loading.value = false;
});
</script>

<template>
  <div class="content__inside" v-if="!loading">
    <div class="content__header">
      <div>
        <h1>{{ currentMenuStore.currentMenu.name }} Menu</h1>
        <p>
          <router-link :to="{ name: 'menus' }">Our Menus</router-link> >
          {{ currentMenuStore.currentMenu.name }}
        </p>
      </div>
      <div class="notice" v-if="currentMenuStore.hasChanges">
        <svg-vue icon="alert-circle"></svg-vue>Menu has unsaved changes
      </div>
    </div>
    <Grid :columns="'1fr 2fr'">
      <SiteList></SiteList>
      <div>
        <div class="menu-view__header">
          <CategoryModal :menuType="currentMenuStore.currentTab" @addCategory="addCategory"></CategoryModal>
          <div class="buttons">
            <button @click="currentMenuStore.currentTab = 'food'"
              :class="{ 'button--bordered': currentMenuStore.currentTab != 'food' }">Food</button>
            <button @click="currentMenuStore.currentTab = 'drink'"
              :class="{ 'button--bordered': currentMenuStore.currentTab != 'drink' }">Drink</button>
          </div>
        </div>
        <div v-if="currentMenuStore.currentTab == 'food'">
          <draggable group="foodCategories" :list="currentMenuStore.food" item-key="name"
            handle=".handle.category-handle">
            <template #item="{ element, index }">
              <MenuCategory :categoryIndex="index" :category="{ ...element }" :type="'food'">
              </MenuCategory>
            </template>
          </draggable>
        </div>
        <div v-if="currentMenuStore.currentTab == 'drink'">
          <draggable group="drinkCategories" :list="currentMenuStore.drink" item-key="name" handle=".cat-handle">
            <template #item="{ element, index }">
              <MenuCategory :categoryIndex="index" :category="{ ...element }" :type="'drink'">
              </MenuCategory>
            </template>
          </draggable>
        </div>
      </div>
    </Grid>
  </div>
  <div class="loading-holder" v-else>
    <LottieAnimation class="loading" ref="anim" :animationData="require('../../../animations/loader.json')"
      :loop="true" />
    <p>Loading menu...</p>
  </div>
</template>

<style scoped lang="scss">
@import '../../../scss/partials/variables';

.loading-holder {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;

  .loading {
    width: 64px;
    height: 64px;
    margin-bottom: var(--grid-gap);
  }
}

.menu-view {
  &__header {
    background: #fff;
    padding: var(--grid-padding);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: var(--inside-padding-horiz);
    z-index: 20;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 0px 0px 0px;
    transition: 0.3s ease;

    .buttons {
      display: flex;
      gap: var(--grid-gap);
    }

    button {
      padding: 10px 30px;
    }

    &.sticky {
      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    }
  }
}

.notice {
  background: var(--black);
  color: #fff;
  padding: 20px;
  display: inline-flex;
  align-items: center;

  svg {
    width: 20px;
    margin-right: 10px;
  }
}

@media screen and (max-width: $breakpoint-md) {

  .menu-view__header,
  .menu-view {
    position: static;
  }

  .content__inside {
    .grid {
      display: block;

      .grid-item {
        position: static;
        height: 100%;
      }
    }
  }
}

@media screen and (max-width: $breakpoint-xs) {
  .menu-view__header {
    padding: 20px;
    display: block;

    .buttons>button {
      width: 100%;
    }
  }

}
</style>
